import { Button, Col, Row } from "antd"
import CustomTextArea from "../../components/_common/CustomTextArea"
import { useState } from "react";
import { set } from "lodash";
import { modifyLink } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";

export interface InputProps {
    labId: any
}

const ModifyLink = ({ labId }: InputProps) => {
    const [previousLink, setPreviousLink] = useState("");
    const [currentLink, setCurrentLink] = useState("");

    const previousLinkChange = (event: any) => {
        setPreviousLink(event.target.value);
    }

    const currentLinkChange = (event: any) => {
        setCurrentLink(event.target.value);
    }

    const _modifyLink = () => {
        modifyLink(labId, previousLink,currentLink)
            .then((result: any) => {
                sucessNotify("اطلاعات با موفقیت ویرایش شد.", undefined, 5000)
               
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })


    }

    const onEditClick = () => {
        _modifyLink();
    }

    return (
        <div className="tab-content-padding">
            <Row>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <CustomTextArea
                        name="title"
                        placeholder="لینک قبلی"
                        value={previousLink}
                        onChange={previousLinkChange}
                    />
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <CustomTextArea
                        name="title"
                        placeholder="لینک جدید"
                        value={currentLink}
                        onChange={currentLinkChange}
                    />
                </Col>
            </Row>
            <Row style={{ justifyContent: 'center' }}>
                <Button type="primary" style={{ backgroundColor: "Green" }} onClick={onEditClick}>ویرایش</Button>
            </Row>


        </div>)
}

export default ModifyLink